require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-morgan-nomura.json") })
        }
      }, "path---blog-author-morgan-nomura");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-morgan-nomura!./.cache/json/blog-author-morgan-nomura.json
// module id = 690
// module chunks = 231608221292675